import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type State = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useScheduleHeaderModal = createWithEqualityFn<State>()(
  (set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }),
  shallow
);

export const useOpenScheduleHeaderModal = () => {
  const open = useScheduleHeaderModal((state) => state.open);
  return { open };
};
